import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import * as api from "@/api/supply";

export const WB_SOURCE_KEY = ["supply", "settings", "wb-source"];
export const WB_COMPARE_KEY = ["supply", "analytics", "wb-compare"];

/** Всё, что считается из заказов/остатка WB: отчёт WB «Распределения», движок, «Производство» и
 *  само сравнение. Ozon/YM источник WB не трогает — их минутный пересчёт тут не нужен. */
const WB_DEPENDENT_KEYS = [
  ["supply", "analytics", "wb"],
  ["supply", "analytics", "allocation"],
  ["supply", "analytics", "production-needs"],
  WB_COMPARE_KEY,
];

/** Общая настройка источника WB (читает любой с правом `supply`). */
export function useWbSource() {
  return useQuery({
    queryKey: WB_SOURCE_KEY,
    queryFn: api.getWbSource,
    staleTime: 60_000,
  });
}

/** Смена источника (только админ). Ошибку показывает вызывающий — у мутации она в `error`. */
export function useSetWbSource() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.setWbSource,
    onSuccess: (v) => {
      qc.setQueryData(WB_SOURCE_KEY, v);
      for (const k of WB_DEPENDENT_KEYS) qc.invalidateQueries({ queryKey: k });
    },
  });
}

/** Сравнение старый × витрина с отсечками страницы; запрос дорогой (два отчёта) — только по
 *  открытию панели. */
export function useWbCompare(
  params: api.CalcParams,
  enabled: boolean,
  top = 200,
) {
  return useQuery({
    queryKey: [...WB_COMPARE_KEY, params, top],
    queryFn: () => api.getWbCompare({ ...params, top }),
    enabled,
    staleTime: 5 * 60_000,
  });
}
